import { UserData } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { produce } from 'immer'
import keys from './shared/keys'

type Variables = {
  restoreId: string
}

export function useUpdateUserRestoreId() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationKey: keys.detail(),
    mutationFn: ({ restoreId }: Variables) =>
      server.post(`/v2/users/me/restore_id/${restoreId}`, {}),
    onSuccess: async (_, { restoreId }) => {
      const userData = client.getQueryData<UserData>(keys.detail())
      if (!userData) {
        return
      }

      await client.cancelQueries({ queryKey: keys.detail() })
      client.setQueryData<UserData>(
        keys.detail(),
        produce(userData, updatedUserData => {
          updatedUserData.restoreId = restoreId
        })
      )
    },
  })
}
